export const FPS = 60;

export const SWEEPER_WIDTH = 47;
